module.exports = __webpack_public_path__ + "f405d01cbed570c59eaeb3daeba2ad29.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-27.png
// module id = 1574
// module chunks = 0